import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
export const BranchACQ155Hublet = {
  name: 'BranchACQ155Hublet',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0155, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.removeSteps([Step.HubletSelection], false));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: Step.CompanyName
};